import { Flex, FlexProps } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { Creator } from '~/clientApi/creator.model';
import { selectCreator } from '~/selectors/creator';
import { useBreakpointValue } from '~/utils-ts';

import { NavBarProps } from '../../MediaPackNavBar.model';
import { getConnectedLinks } from './ShareNavBar.helpers';
import { ButtonsSection } from './components/ButtonsSection';
import { CreatorName } from './components/CreatorName/CreatorName';
import { NavLinks } from './components/NavLinks';
import { ToggleMenu } from './components/ToggleMenu';

interface Props extends NavBarProps, FlexProps {
  onShare: () => void;
}

export const ShareNavBar: React.FC<Props> = ({
  creatorBenchmarks,
  creatorInsights,
  mediaPack,
  pdfImages,
  onShare,
  activeSection,
  sectionsRefs = [],
  isSharedView,
  ...props
}) => {
  const creator = useSelector(selectCreator);
  const shouldDisplayHamburgerMenu = useBreakpointValue({
    base: true,
    md: true,
    lg: true,
    xl: false,
  });

  return (
    <Flex
      as="nav"
      position="sticky"
      height={16}
      alignItems="center"
      top={0}
      zIndex="sticky"
      background="primary.900"
      {...props}
    >
      <Flex
        justifyContent="space-between"
        alignItems="center"
        maxWidth="1100px"
        paddingX={{
          base: 6,
          md: 12,
          xl: 0,
        }}
        margin="auto"
        width="100%"
      >
        {shouldDisplayHamburgerMenu ? (
          <ToggleMenu
            activeSection={activeSection}
            navigationLinks={getConnectedLinks(mediaPack.platforms)}
            sectionsRefs={sectionsRefs}
          />
        ) : (
          <Flex alignItems="center" width="100%">
            <CreatorName
              creator={creator as Creator}
              color="white"
              fontWeight="medium"
              fontSize="xl"
            />

            <Flex gap={10} marginLeft={10} data-testid="nav-links">
              <NavLinks
                activeIndex={activeSection}
                navigationLinks={getConnectedLinks(mediaPack.platforms)}
                sectionsRefs={sectionsRefs}
              />
            </Flex>
          </Flex>
        )}

        <ButtonsSection
          creator={creator as Creator}
          creatorBenchmarks={creatorBenchmarks}
          creatorInsights={creatorInsights}
          mediaPack={mediaPack}
          pdfImages={pdfImages}
          onShare={onShare}
          isSharedView={isSharedView}
        />
      </Flex>
    </Flex>
  );
};
